export const TagConstantes = {
  DOM_TOM: "CMD-DomTom",
  GESTIONNAIRE_CATALOGUE: "CMD-GestionnaireCatalogue",
  GESTIONNAIRE_STOCK: "CMD-GestionnaireStocke",
  MEDECIN: "CMD-Medecin",
  BIOLOGISTE: "CMD-Biologiste",
  VALIDEUR: "CMD-ValidationCommande"
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/constantes/tag.constantes.ts